import { isProduction } from "core/env";

export function fbq(...args) {
  if (isProduction()) return window.fbq(...args);
  return;
}



// WEBPACK FOOTER //
// ./src/core/integrations/fb_pixel/index.js